import { render } from "./ObjectLibrary.vue?vue&type=template&id=db6d8de8&scoped=true&ts=true"
import script from "./ObjectLibrary.vue?vue&type=script&lang=ts"
export * from "./ObjectLibrary.vue?vue&type=script&lang=ts"

import "./ObjectLibrary.vue?vue&type=style&index=0&id=db6d8de8&scoped=true&lang=scss"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db6d8de8"]])

export default __exports__